import { variantsToSrcSet } from "app/common/utilities/html"
import { ImageVM } from "app/models"
import { Link, RouteUrlObject } from "blitz"
import { array } from "fp-ts"
import { pipe } from "fp-ts/function"
import React, { FC, Key } from "react"
import { IconType } from "react-icons"
import { tw } from "twind"

interface Link {
  image: ImageVM
  key: Key
  routeUrl: RouteUrlObject | string
  text: string
}

interface Props {
  Icon: IconType
  className?: string
  links: Link[]
  title: string
}

export const SideHeading: FC<{ Icon: IconType; title: string }> = ({ Icon, title }) => (
  <div className={tw(`flex items-center gap-3`, `mb-1`, `pb-2`, `border(b-2 red-300)`)}>
    <Icon className={tw(`w-6 h-6 inline-block`, `text-red-600`)} />
    <span className={tw(`text-lg font-semibold`)}>{title}</span>
  </div>
)

export const SideLinks: FC<Props> = ({ Icon, className, links, title }) => (
  <div className={className}>
    <SideHeading Icon={Icon} title={title} />
    <ul className={tw(`flex(& col)`, `divide(y gray-300)`)}>
      {pipe(
        links,
        array.map(
          ({ image: { alternateText, height, url, variants, width }, key, routeUrl, text }) => (
            <li key={key}>
              <Link href={routeUrl}>
                <a className={tw(`py-3`, `flex items-center gap-4`, `text-sm font-semibold`)}>
                  <img
                    alt={alternateText}
                    className={tw(`w-16`, `overflow-hidden`)}
                    height={height}
                    sizes={"100px"}
                    src={url}
                    srcSet={variantsToSrcSet(variants)}
                    width={width}
                  />
                  {text}
                </a>
              </Link>
            </li>
          )
        )
      )}
    </ul>
  </div>
)
